import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import { ErrorState } from "../components/ui";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
  requestId: string | null;
}

export class GlobalErrorBoundary extends Component<Props, State> {
  state: State = { error: null, requestId: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, requestId: crypto.randomUUID() };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("client_error_boundary", {
      message: error.message,
      componentStack: info.componentStack,
    });
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <main className="centered-page">
          <ErrorState
            title="Ứng dụng gặp lỗi ngoài dự kiến"
            description="Vui lòng tải lại trang. Nếu lỗi tiếp diễn, gửi mã yêu cầu cho quản trị viên."
            requestId={this.state.requestId ?? undefined}
            action={{ label: "Tải lại", onClick: () => window.location.reload() }}
          />
        </main>
      );
    }
    return this.props.children;
  }
}
